import { Invoice, InvoiceTransaction } from "../../domain/entities/Invoice"
import { InvoiceStatus } from "../../domain/enum/invoiceStatus.enum"
import { SellersModel } from "./SellersModel"

interface ConstructorParams {
	id: number
	invoiceNumber: string
	createdAt: Date
	paymentDate?: string | null
	emissionDate?: string | null
	period: string
	sellerId: number
	status: InvoiceStatus
	total: number
	totalFee: number
	sellerPrice: number
	sellerPayment: number
	sellerPaymentDate?: string | null
	sellerCollectionDate?: string | null
	transactions?: InvoiceTransaction[]
	seller?: SellersModel
	sellerOfficeId?: number | null
	sellerOfficeName?: string | null
}

export class InvoiceModel {
	public id: number
	public invoiceNumber: string
	public createdAt: Date
	public paymentDate?: string | null
	public emissionDate?: string | null
	public period: string
	public sellerId: number
	public status: InvoiceStatus
	public total: number
	public totalFee: number
	public sellerPrice: number
	public sellerPayment: number
	public sellerPaymentDate?: string | null
	public sellerCollectionDate?: string | null
	public transactions?: InvoiceTransaction[]
	public seller?: SellersModel
	public sellerOfficeId?: number | null
	public sellerOfficeName?: string | null

	public constructor(invoice: ConstructorParams) {
		this.id = invoice.id
		this.invoiceNumber = invoice.invoiceNumber
		this.createdAt = invoice.createdAt
		this.paymentDate = invoice.paymentDate
		this.emissionDate = invoice.emissionDate
		this.period = invoice.period
		this.sellerId = invoice.sellerId
		this.status = invoice.status
		this.total = invoice.total
		this.totalFee = invoice.totalFee
		this.sellerPaymentDate = invoice.sellerPaymentDate
		this.sellerCollectionDate = invoice.sellerCollectionDate
		this.transactions = invoice.transactions
		this.seller = invoice.seller
		this.sellerPayment = invoice.sellerPayment
		this.sellerPrice = invoice.sellerPrice
		this.sellerOfficeId = invoice.sellerOfficeId
		this.sellerOfficeName = invoice.sellerOfficeName
	}

	static fromRawJson = (rawJson: any): InvoiceModel => {
		return new InvoiceModel({
			...rawJson,
			seller: rawJson.seller ? SellersModel.fromRawJson(rawJson.seller) : undefined
		})
	}

	static fromDomain = (invoice: Invoice): InvoiceModel => {
		return new InvoiceModel({
			...invoice,
			seller: invoice.seller ? SellersModel.fromDomain(invoice.seller) : undefined
		})
	}
}

declare module "./InvoiceModel" {
	interface InvoiceModel {
		toDomain(): Invoice
	}
}

InvoiceModel.prototype.toDomain = function (): Invoice {
	const data = this
	return new Invoice({
		...data,
		seller: data?.seller?.toDomain()
	})
}
